module.exports = __webpack_public_path__ + "img/46.a895c834.jpg";